import { Node, mergeAttributes } from '@tiptap/core';

interface SubtitleOptions {
  setNewParagraphAlignment: Function;
}

export const Subtitle = Node.create<SubtitleOptions>({
  name: 'subtitle',
  group: 'block',
  content: 'inline*',

  parseHTML() {
    return [
      {
        tag: 'subtitle',
        getAttrs: node => {
          if (typeof node === 'string') return false;
          return (node as HTMLElement).classList.contains('editor-subtitle') ? {} : false;
        }
      }
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['subtitle', mergeAttributes(HTMLAttributes, { class: 'editor-subtitle' }), 0];
  },

  addAttributes() {
    return {
      textAlign: {
        default: 'center',
        parseHTML: element => element.style.textAlign || 'center',
        renderHTML: attributes => {
          if (!attributes.textAlign) return {};
          return {
            style: `text-align: ${attributes.textAlign}`
          };
        }
      }
    };
  },

  addOptions() {
    return {
      setNewParagraphAlignment: () => {}
    };
  },

  addKeyboardShortcuts() {
    return {
      Enter: () => this.options.setNewParagraphAlignment()
    };
  }
});
